import React from "react";
import clsx from "clsx";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {
  Grid,
  TextField,
  Button,
  CircularProgress,
  Tab,
  Tabs,
  Divider,
  ListItemText,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  Checkbox,
} from "@material-ui/core";
import { EventEmitter } from "../events/EventEmitter";
import { ReportingService } from "../services/ReportingService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import history from "../utils/history";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import emptyTrash from "../assets/images/empty_trash.png";
import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { EmployeeService } from "../services/EmployeeService";
import { DASHBOARD_TYPES, getMomentDate, ROLES } from "../constants/constants";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import AddIcon from "@material-ui/icons/Add";
import { ThemeProvider } from "@material-ui/core/styles";
import { defaultTheme } from "../utils/theme";
import { AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import { VisitorService } from "../services/VisitorService";
import { DataConvertAsync } from "../utils/DataConvertAsync";
import LoadingComponents from "../components/LoadingComponents";
import { isEmptyArray } from "formik";
import TabPanel from "../components/TabPanel";
import PreUseLineGraphComponent from "../reporting/PreUseLineGraphComponent";
import BarGraphComponentV2 from "../reporting/BarGraphComponentV2";
import EquipmentStatusTableComponent from "../components/EquipmentStatusTableComponent";
const CustomChecked = withStyles({
  colorSecondary: {
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "orange",
    },
  },
})(Checkbox);

const drawerWidth = 260;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
    },
    gridRoot: {
      flexGrow: 1,
    },
    rtl: { value: theme.direction },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "rgba(0,255,255, 0.8)",
      },
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    radio: {
      "&$checked": {
        color: "#f96500",
      },
    },
    checked: {},
    container: {
      width: "100%",
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    title: {
      flex: "1 1 100%",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    extendedIcon: {
      marginRight: 1,
    },
    table: {
      minWidth: 700,
    },
    underline: {
      "&&&:before": {
        borderBottom: "none",
      },
      "&&:after": {
        borderBottom: "none",
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    drawerPaper: {
      width: drawerWidth,
    },
    tableCell: {
      padding: "0px 0px",
    },
  });
interface Props extends WithStyles<typeof styles> {
  profileData: any;
  onLogOut: any;
  title: any;
  type: any;
  location?: any;
}
class PreUseInspectionDashboard extends React.Component<Props> {
  state = {
    open: false,
    selectedMenuItem: "Screening Dashboard",
    companyId: "",
    company: { name: "" },
    isFiltering: false,
    isFilteringCancel: false,
    isComparisonFiltering: false,
    employeeFiltered: { _id: "", fullName: "" },
    filterStartDate: new Date(),
    filterEndDate: new Date(),

    filterStartOldDate: new Date(),
    filterEndOldDate: new Date(),

    filterComparisonDate: new Date(),
    employees: Array<any>(),
    visitors: Array<any>(),
    employeeFilteredData: Array<any>(),
    filteredTableData: Array<any>(),
    isLoading: false,
    openGraphDetailsDialog: false,

    tabValue: 0,
    radioOEEValue: "",
    radioUtilityValue: "",
    radioPreuseValue: "AllShifts",
    radioEffectivenessValue: "",

    radioComplianceValue: "AllShifts",
    radioBreakdownValue: "AllShifts",
    radioStandingValue: "AllShifts",

    checkedOEE: false,
    checkedQuality: false,
    checkedAvailability: true,
    checkedUtilisation: true,

    selectedOEEMachineItem: "",
    selectedUtilityMachineItem: "",
    selectedPreuseMachineItem: "All",

    selectedPreuseComplianceItem: "All",
    selectedPreuseBreakdownItem: "All",
    selectedPreuseStandingItem: "All",

    selectedPreuseMachineStatusItem: "All",

    utilityShiftIsNotEmpty: false,
    OEEShiftIsNotEmpty: false,
    preuseShiftIsNotEmpty: false,
    effectivenssIsNotEmpty: false,

    complianceIsNotEmpty: false,

    machineStatusIsNotEmpty: false,

    breakdownIsNotEmpty: false,
    standingIsNotEmpty: false,

    PreUseData: Array<any>(),
    originalList: Array<any>(),

    SHIFT_DURATION: 0,

    mBarDataPartA: Array<any>(),
    mBarPreuseData: Array<any>(),
    mBarDataPartC: Array<any>(),
    mBarDataV2: Array<any>(),

    mMachineOEEData: Array<any>(),
    mMachineUtilityData: Array<any>(),

    mMachineStatusData: Array<any>(),
    mFilteredMachineStatusData: Array<any>(),

    mComplianceData: Array<any>(),

    mBreakdownData: Array<any>(),
    mStandingData: Array<any>(),

    mMachineEffectivenessData: Array<any>(),

    mBarDataLoading: false,
  };

  componentDidMount = () => {
    let startDate = moment(new Date()).subtract(7, "days").toDate();
    let endDate = moment(new Date()).toDate();
    this.setState(
      {
        filterStartDate: startDate,
        filterEndDate: endDate,
        isFiltering: true,
      },
      () => {
        this.getData();
      }
    );
  };
  componentWillMount = () => {};
  componentDidUpdate = (prevProps: any) => {
    if (prevProps.profileData.companyId !== this.props.profileData.companyId) {
      this.getData();
    }
  };

  getData = () => {
    let companyId =
      this.props.profileData && this.props.profileData.companyId
        ? this.props.profileData.companyId
        : this.props.location &&
          this.props.location.state &&
          this.props.location.state.companyData._id
        ? this.props.location.state.companyData._id
        : "";
    if (companyId) {
      this.setState(
        {
          companyId: companyId,
        },
        () => {
          this.getCompanyDetails();
        }
      );
    }
  };
  getInspectionByEquipments = (equipments: any, inspections: any) => {
    let resultInspections = new Array<any>();
    inspections.map((item: any) => {
      let machine =
        item.machine && item.machine.length > 0 ? item.machine[0] : null;
      if (machine && machine.value === equipments) {
        resultInspections.push(item);
      }
      return null;
    });
    return resultInspections;
  };
  getEquipmentsFromInspections = (inspections: any) => {
    let resultEquipments = new Array<any>();
    inspections.map((item: any) => {
      let machine =
        item.machine && item.machine.length > 0 ? item.machine[0] : null;
      let foundObj = resultEquipments.filter((obj: any) => {
        return obj.machine === machine.value;
      });
      if (foundObj && foundObj.length > 0) {
      } else {
        if (machine && machine.value) {
          resultEquipments.push({ machine: machine.value });
        }
      }
      return null;
    });
    return resultEquipments.sort((a: any, b: any) =>
      a.machine > b.machine ? 1 : -1
    );
  };

  drawBarGraphs = () => {
    let dataConvertAsync: DataConvertAsync = new DataConvertAsync();
    let shifts = dataConvertAsync.getShifts(this.state.PreUseData);
    let equipments = this.getEquipmentsFromInspections(this.state.PreUseData);
    shifts.forEach((shiftItem: any) => {
      if (this.state.tabValue === 0) {
        dataConvertAsync
          .getPreUseMachineStatusData(this.state.PreUseData)
          .then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mMachineStatusData: resp,
                isLoading: false,
                machineStatussNotEmpty: false,
              });
            } else {
              this.setState({
                mMachineStatusData: [],
                isLoading: false,
                machineStatussNotEmpty: true,
              });
            }
          });
      } else {
        this.setState({
          machineStatussNotEmpty: true,
          isLoading: false,
        });
      }
      if (this.state.tabValue === 1) {
        if (shiftItem.shift === this.state.radioPreuseValue) {
          let items =
            this.state.selectedPreuseMachineItem === "All"
              ? shiftItem.inspections
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseMachineItem,
                  shiftItem.inspections
                );
          dataConvertAsync
            .convertToPreUseBarDataTemp(items)
            .then((resp: any) => {
              if (resp && resp.length > 0) {
                this.setState({
                  mBarDataPartA: resp,
                  preuseShiftIsNotEmpty: false,
                });
              } else {
                this.setState({
                  mBarDataPartA: [],
                  preuseShiftIsNotEmpty: true,
                });
              }
            });
        } else if (this.state.radioPreuseValue === "AllShifts") {
          let items =
            this.state.selectedPreuseMachineItem === "All"
              ? this.state.PreUseData
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseMachineItem,
                  this.state.PreUseData
                );
          dataConvertAsync
            .convertToPreUseBarDataTemp(items, true)
            .then((resp: any) => {
              if (resp && resp.length > 0) {
                this.setState({
                  mBarDataPartA: resp,
                  isLoading: false,
                  preuseShiftIsNotEmpty: false,
                });
              } else {
                this.setState({
                  mBarDataPartA: [],
                  isLoading: false,
                  preuseShiftIsNotEmpty: true,
                });
              }
            });
          dataConvertAsync
            .getPreUseMachineData(this.state.PreUseData)
            .then((resp: any) => {
              if (resp && resp.length > 0) {
                this.setState({
                  mBarPreuseData: resp,
                  isLoading: false,
                  preuseShiftIsNotEmpty: false,
                });
              } else {
                this.setState({
                  mBarPreuseData: [],
                  isLoading: false,
                  preuseShiftIsNotEmpty: true,
                });
              }
            });
        } else {
          this.setState({
            isLoading: false,
            preuseShiftIsNotEmpty: true,
          });
        }
      } else {
        this.setState({
          isLoading: false,
          preuseShiftIsNotEmpty: true,
        });
      }
      if (this.state.tabValue === 2) {
        if (shiftItem.shift === this.state.radioComplianceValue) {
          let items =
            this.state.selectedPreuseComplianceItem === "All"
              ? shiftItem.inspections
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseComplianceItem,
                  shiftItem.inspections
                );
          dataConvertAsync.getPreUseComplianceData(items).then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mComplianceData: resp,
                isLoading: false,
                complianceIsNotEmpty: false,
              });
            } else {
              this.setState({
                mComplianceData: [],
                isLoading: false,
                complianceIsNotEmpty: true,
              });
            }
          });
        } else if (this.state.radioComplianceValue === "AllShifts") {
          let items =
            this.state.selectedPreuseComplianceItem === "All"
              ? this.state.PreUseData
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseComplianceItem,
                  this.state.PreUseData
                );
          dataConvertAsync.getPreUseComplianceData(items).then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mComplianceData: resp,
                isLoading: false,
                complianceIsNotEmpty: false,
              });
            } else {
              this.setState({
                mComplianceData: [],
                isLoading: false,
                complianceIsNotEmpty: true,
              });
            }
          });
        } else {
          this.setState({
            complianceIsNotEmpty: true,
            isLoading: false,
          });
        }
      } else {
        this.setState({
          complianceIsNotEmpty: true,
          isLoading: false,
        });
      }
      if (this.state.tabValue === 3) {
        if (shiftItem.shift === this.state.radioBreakdownValue) {
          let items =
            this.state.selectedPreuseBreakdownItem === "All"
              ? shiftItem.inspections
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseBreakdownItem,
                  shiftItem.inspections
                );
          dataConvertAsync.getPreUseBreakdownData(items).then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mBreakdownData: resp,
                isLoading: false,
                breakdownIsNotEmpty: false,
              });
            } else {
              this.setState({
                mBreakdownData: [],
                isLoading: false,
                breakdownIsNotEmpty: true,
              });
            }
          });
        } else if (this.state.radioBreakdownValue === "AllShifts") {
          let items =
            this.state.selectedPreuseBreakdownItem === "All"
              ? this.state.PreUseData
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseBreakdownItem,
                  this.state.PreUseData
                );
          dataConvertAsync.getPreUseBreakdownData(items).then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mBreakdownData: resp,
                isLoading: false,
                breakdownIsNotEmpty: false,
              });
            } else {
              this.setState({
                mBreakdownData: [],
                isLoading: false,
                breakdownIsNotEmpty: true,
              });
            }
          });
        } else {
          this.setState({
            breakdownIsNotEmpty: true,
            isLoading: false,
          });
        }
      } else {
        this.setState({
          breakdownIsNotEmpty: true,
          isLoading: false,
        });
      }
      if (
        this.state.tabValue === 4 &&
        this.props.type !== DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD
      ) {
        if (shiftItem.shift === this.state.radioStandingValue) {
          let items =
            this.state.selectedPreuseStandingItem === "All"
              ? shiftItem.inspections
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseStandingItem,
                  shiftItem.inspections
                );
          let _default = this.state.selectedPreuseStandingItem
            ? this.state.selectedPreuseStandingItem
            : "";
          dataConvertAsync.getPreUseStandingData(items).then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mStandingData: resp,
                selectedPreuseStandingItem: _default
                  ? _default
                  : equipments.length > 0
                  ? equipments[0].machine
                  : "",
                standingIsNotEmpty: false,
              });
            } else {
              this.setState({
                mStandingData: [],
                isLoading: false,
                standingIsNotEmpty: true,
              });
            }
          });
        } else if (this.state.radioStandingValue === "AllShifts") {
          let items =
            this.state.selectedPreuseStandingItem === "All"
              ? this.state.PreUseData
              : this.getInspectionByEquipments(
                  this.state.selectedPreuseStandingItem,
                  this.state.PreUseData
                );
          let _default = this.state.selectedPreuseStandingItem
            ? this.state.selectedPreuseStandingItem
            : "";
          dataConvertAsync.getPreUseStandingData(items).then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mStandingData: resp,
                selectedPreuseStandingItem: _default
                  ? _default
                  : equipments.length > 0
                  ? equipments[0].machine
                  : "",
                standingIsNotEmpty: false,
              });
            } else {
              this.setState({
                mStandingData: [],
                isLoading: false,
                standingIsNotEmpty: true,
              });
            }
          });
        } else {
          this.setState({
            isLoading: false,
            standingIsNotEmpty: true,
          });
        }
      } else {
        this.setState({
          standingIsNotEmpty: true,
          isLoading: false,
        });
      }
      if (
        shiftItem.shift === this.state.radioUtilityValue &&
        ((this.state.tabValue === 5 &&
          this.props.type !==
            DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD) ||
          (this.state.tabValue === 4 &&
            this.props.type ===
              DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD))
      ) {
        dataConvertAsync
          .getPreUseMachineData(shiftItem.inspections)
          .then((resp: any) => {
            let _default = this.state.selectedUtilityMachineItem
              ? this.state.selectedUtilityMachineItem
              : "";
            if (resp && resp.length > 0) {
              let strObj = JSON.stringify(resp);
              let isAvailable = strObj.includes(_default);
              this.setState({
                mMachineUtilityData: resp,
                isLoading: false,
                utilityShiftIsNotEmpty: false,
                selectedUtilityMachineItem:
                  _default && isAvailable ? _default : resp[0].machine,
              });
            } else {
              this.setState({
                mMachineUtilityData: [],
                isLoading: false,
                utilityShiftIsNotEmpty: true,
              });
            }
          });
      } else {
        this.setState({
          isLoading: false,
          utilityShiftIsNotEmpty: true,
        });
      }
      if (
        shiftItem.shift === this.state.radioOEEValue &&
        ((this.state.tabValue === 5 &&
          this.props.type !==
            DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD) ||
          (this.state.tabValue === 4 &&
            this.props.type ===
              DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD))
      ) {
        dataConvertAsync
          .getPreUseMachineData(shiftItem.inspections)
          .then((resp: any) => {
            let _default = this.state.selectedOEEMachineItem
              ? this.state.selectedOEEMachineItem
              : "";
            if (resp && resp.length > 0) {
              this.setState({
                mMachineOEEData: resp,
                OEEShiftIsNotEmpty: false,
                isLoading: false,
                selectedOEEMachineItem: _default ? _default : resp[0].machine,
              });
            } else {
              this.setState({
                mMachineOEEData: [],
                isLoading: false,
                OEEShiftIsNotEmpty: true,
              });
            }
          });
      } else {
        this.setState({
          isLoading: false,
          OEEShiftIsNotEmpty: true,
        });
      }
      if (
        this.state.filterComparisonDate &&
        shiftItem.shift === this.state.radioEffectivenessValue &&
        ((this.state.tabValue === 6 &&
          this.props.type !==
            DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD) ||
          (this.state.tabValue === 5 &&
            this.props.type ===
              DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD))
      ) {
        let momentComparison = getMomentDate(
          this.state.filterComparisonDate.toDateString(),
          "DD/MM/YYYY"
        );
        dataConvertAsync
          .getPreUseMachineEffectivenessData(
            shiftItem.inspections,
            momentComparison
          )
          .then((resp: any) => {
            if (resp && resp.length > 0) {
              this.setState({
                mMachineEffectivenessData: resp,
                isLoading: false,
                effectivenssIsNotEmpty: false,
              });
            } else {
              this.setState({
                mMachineEffectivenessData: [],
                isLoading: false,
                effectivenssIsNotEmpty: true,
              });
            }
          });
      } else {
        this.setState({
          effectivenssIsNotEmpty: true,
          isLoading: false,
        });
      }
      return null;
    });
  };

  drawGraphs = () => {};
  getVisitorsByCompany = () => {
    if (!this.state.companyId) {
      return;
    }
    let visitorService: VisitorService = new VisitorService();
    this.setState({
      isLoading: true,
    });

    visitorService.getVisitorsByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.visitors) {
            this.setState({
              visitors: resp.visitors,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );
  };
  getEmployeesByCompany = () => {
    if (!this.state.companyId) {
      return;
    }
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });

    employeeService.getEmployeesByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.employees) {
            this.setState({
              employees: resp.employees,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  getCompanyDetails = () => {
    if (!this.state.companyId) {
      return;
    }
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });
    employeeService.getCompanyDetailsAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.company) {
            let shiftDuration = this.getShiftsDuractionForCompany(resp.company);
            let defaultShift = this.getDefaultShift(resp.company);
            this.setState(
              {
                company: resp.company,
                SHIFT_DURATION: shiftDuration,
                radioOEEValue: defaultShift,
                radioUtilityValue: defaultShift,
              },
              () => {
                if (this.state.isFiltering) {
                  this.requestDataForDateRange();
                } else {
                  this.getPreUseReportingData();
                }
                this.getEmployeesByCompany();
                this.getVisitorsByCompany();
              }
            );
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  getDateFromShift = (shiftTime: any) => {
    let currentDate = new Date();
    if (shiftTime && shiftTime.split(":").length > 1) {
      let shiftTimeObj = shiftTime.split(":");
      currentDate.setHours(
        Number(shiftTimeObj[0]) > 12
          ? Number(shiftTimeObj[0]) % 2
          : Number(shiftTimeObj[0])
      );
      currentDate.setMinutes(
        Number(shiftTimeObj[0]) > 12
          ? Number(shiftTimeObj[1]) % 2
          : Number(shiftTimeObj[1])
      );
    }
    return currentDate;
  };

  getShiftsDuractionForCompany = (company: any) => {
    if (company.shifts && company.shifts.length > 0) {
      let shift = company.shifts[0];
      let startShiftDate = this.getDateFromShift(shift.startOfShift);
      var startOfShift = moment(startShiftDate.toISOString());
      let endShiftDate = this.getDateFromShift(shift.endOfShift);
      var endOfShift = moment(endShiftDate.toISOString());
      var duration = moment.duration(startOfShift.diff(endOfShift));
      var minutes = duration.asMinutes();
      return minutes;
    }
  };

  getDefaultShift = (company: any) => {
    let shiftValue = "";
    if (company.shifts && company.shifts.length > 0) {
      let shift = company.shifts[0];
      shiftValue = shift.label;
    }
    return shiftValue;
  };

  getShiftTitles = (company: any) => {
    let shiftsTitles = new Array<any>();
    if (company.shifts && company.shifts.length > 0) {
      company.shifts.map((shiftItem: any, index: any) => {
        shiftsTitles.push(shiftItem.label);
        return null;
      });
    }
    return shiftsTitles;
  };

  getPreUseReportingData = () => {
    let reportingService: ReportingService = new ReportingService();
    reportingService.getPreUseReportsByCompany(
      this.state.companyId,
      this.props.type,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                PreUseData: resp.data,
                originalList: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  dataNotAvailable = () => {
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          style={{ marginTop: 10, textAlign: "center" }}
        >
          {"Data available".toUpperCase()}
        </Typography>
      </div>
    );
  };
  renderPersonalisedGraph = () => {
    // data.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
  };
  redirect = () => {
    let paramObj = {
      profileData: this.props.profileData,
      companyId: this.state.companyId,
    };
    history.push({
      pathname: `/dashboard/details`,
      state: paramObj,
    });
  };
  handleClick = () => {
    this.redirect();
  };

  handleApplyFilter = () => {
    this.setState(
      {
        isFiltering: !this.state.isFiltering,
        isFilteringCancel: true,
      },
      () => {
        if (!this.state.isFiltering) {
          this.getCompanyDetails();
        } else {
          this.requestDataForDateRange();
        }
      }
    );
  };
  handleApplyComparisonFilter = () => {
    this.setState(
      {
        isComparisonFiltering: !this.state.isComparisonFiltering,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  requestDataForDateRange = () => {
    var compareStartDate = moment(this.state.filterStartDate).format(
      "YYYY-MM-DD"
    );
    var compareEndDate = moment(this.state.filterEndDate).format("YYYY-MM-DD");
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getPreUseReportsBetweenTwoDatesByCompanyAsync(
      this.state.companyId,
      this.props.type,
      compareStartDate,
      compareEndDate,
      this.state.employeeFiltered && this.state.employeeFiltered._id
        ? this.state.employeeFiltered._id
        : null,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                PreUseData: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  handleFilterStartDateChange = (date: Date | null) => {
    if (!this.state.employeeFiltered || !this.state.employeeFiltered._id) {
      this.setState(
        {
          filterStartOldDate: this.state.filterStartDate,
          isFilteringCancel: false,
        },
        () => {
          this.setState({
            filterStartDate: date,
            isFiltering: false,
          });
        }
      );
    } else {
      this.setState(
        {
          filterStartOldDate: this.state.filterStartDate,
          isFilteringCancel: false,
        },
        () => {
          this.setState({
            filterStartDate: date,
            isFiltering: false,
          });
        }
      );
    }
  };
  handleFilterComparisonDateChange = (date: Date | null) => {
    this.setState(
      {
        filterComparisonDate: date,
        isComparisonFiltering: !this.state.isComparisonFiltering,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };
  handleFilterEndDateChange = (date: Date | null) => {
    if (!this.state.employeeFiltered || this.state.employeeFiltered._id) {
      this.setState(
        {
          filterEndOldDate: this.state.filterEndDate,
          isFilteringCancel: false,
        },
        () => {
          this.setState({
            filterEndDate: date,
            isFiltering: false,
          });
        }
      );
    } else {
      this.setState(
        {
          filterEndOldDate: this.state.filterEndDate,
          isFilteringCancel: false,
        },
        () => {
          this.setState({
            filterEndDate: date,
            isFiltering: false,
          });
        }
      );
    }
  };

  getEmployeeDetails = () => {
    let employeeDetails = this.state.employees.filter((employee: any) => {
      return employee.fullName === this.state.employeeFiltered.fullName;
    });
    if (employeeDetails && employeeDetails.length > 0) {
      return employeeDetails[0];
    } else {
      return null;
    }
  };

  handleOnTextChanged = (event: any) => {
    if (event && event.target && event.target.value) {
      let value = event.target.value;
      this.applyEmployeeFilter(value);
    }
  };

  applyEmployeeFilter = (person: any) => {
    let company: any = this.state.company;
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    var compareStartDate = moment(this.state.filterStartDate, "YYYY-MM-DD");
    var compareEndDate = moment(this.state.filterEndDate, "YYYY-MM-DD");
    reportingService.getPreUseReportsBetweenTwoDatesByCompanyAsync(
      company._id,
      this.props.type,
      compareStartDate,
      compareEndDate,
      person._id,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp) {
            this.setState(
              {
                employeeFiltered: person,
                PreUseData: resp.data,
                employeeFilteredData: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );
  };
  onToolBarButtonClicked = () => {
    if (this.props.onLogOut) {
      this.props.onLogOut();
    }
    history.push({
      pathname: `/login`,
      state: {},
    });
  };

  openAddData = () => {
    clearInterval();
    this.setState({
      openAddDataDialog: true,
    });
  };

  onToolBarCloseButtonClicked = () => {
    history.goBack();
  };

  getGraphTitle = () => {
    return "";
  };

  getPersonalidedGraphTitle = () => {
    return "";
  };
  renderLoadingAwait = () => {
    return (
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          height: 500,
        }}
      >
        <CircularProgress color="secondary" />
      </div>
    );
  };

  getBarColors = (data: any) => {
    if (data) {
      let goData = 0;
      let noGoData = 0;
      let goButData = 0;
      data.map((item: any) => {
        goData += item.GO > 0 ? 1 : 0;
        noGoData += item.NO_GO > 0 ? 1 : 0;
        goButData += item.GO_BUT > 0 ? 1 : 0;
        return null;
      });
      if (goData > 0 && noGoData > 0 && goButData > 0) {
        return ["green", "red", "orange"];
      }
      if (goData > 0 && noGoData > 0) {
        return ["green", "red"];
      }
      if (goData > 0 && goButData > 0) {
        return ["green", "orange"];
      }
      if (noGoData > 0 && goButData > 0) {
        return ["red", "orange"];
      }
      if (goData > 0) {
        return ["green"];
      }
      if (noGoData > 0) {
        return ["red"];
      }
      if (goButData > 0) {
        return ["red"];
      }
    }
  };

  renderStatisticTable = (type: any) => {
    return (
      <div
        style={{
          width: "100%",
          height: 500,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {this.state.mBarDataPartA && this.state.mBarDataPartA.length > 0 && (
          <BarGraphComponentV2
            data={this.state.mBarDataPartA[0]}
            legendAxisLeft={"Totals"}
            legendAxisBelow={"Questions"}
            indexBy={"Question"}
            keys={["GO", "NO-GO", "GO-BUT"]}
            size={"L"}
            showLabels={false}
            colors={(d: any) => {
              return d.id === "GO"
                ? d.data.GO_Color
                : d.id === "NO-GO"
                ? d.data.NO_Color
                : d.data.GO_BUT_Color;
            }}
            hideLengends={true}
            customLengends={[
              { label: "GO", color: "green" },
              { label: "NO-GO", color: "red" },
              { label: "GO-BUT", color: "orange" },
            ]}
          />
        )}
      </div>
    );
  };

  renderUtilisationCharts = (machineItem: any) => {
    let mUtilisationData = {
      id: "Utilisation",
      color: "orange",
      priority: 4,
      data: machineItem.utilisationData,
    };
    let mAvailabilityData = {
      id: "Availability",
      color: "blue",
      priority: 3,
      data: machineItem.availabilityData,
    };

    let mQualityData = {
      id: "Quality",
      color: "red",
      priority: 2,
      data: machineItem.qualityData,
    };

    let mOEEData = {
      id: "OEE",
      color: "brown",
      priority: 1,
      data: machineItem.OEEData,
    };

    mUtilisationData.data.sort(
      (a: any, b: any) =>
        moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
    );
    mAvailabilityData.data.sort(
      (a: any, b: any) =>
        moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
    );
    let colorSeries = new Array<any>();
    let graphsData = new Array<any>();
    if (this.state.checkedUtilisation) {
      graphsData.push(mUtilisationData);
      colorSeries.push(mUtilisationData.color);
    }
    if (this.state.checkedAvailability) {
      graphsData.push(mAvailabilityData);
      colorSeries.push(mAvailabilityData.color);
    }

    if (this.state.checkedOEE) {
      graphsData.push(mOEEData);
      colorSeries.push(mOEEData.color);
    }
    if (this.state.checkedQuality) {
      graphsData.push(mQualityData);
      colorSeries.push(mQualityData.color);
    }
    graphsData.sort((a: any, b: any) => (a.priority < b.priority ? 1 : -1));
    if (
      !this.state.checkedAvailability &&
      !this.state.checkedOEE &&
      !this.state.checkedUtilisation &&
      !this.state.checkedQuality
    ) {
      return (
        <div
          style={{
            height: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          }}
        >
          <img
            src={emptyTrash}
            style={{ width: 40, height: 40 }}
            alt="Empty Trash"
          />
          <Typography
            variant="h5"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`Nothing selected`.toUpperCase()}
          </Typography>
        </div>
      );
    }
    if (mUtilisationData.data.length > 0 || mAvailabilityData.data.length > 0) {
      return (
        <PreUseLineGraphComponent
          data={graphsData}
          xLabel={"Utilisation(%)"}
          yLabel={"Availability(%)"}
          colorSeries={colorSeries}
        />
      );
    } else {
      return <div>sdgsd</div>;
    }
  };
  renderMachineEffectivenessCharts = (hasData: any) => {
    let result = this.state.mMachineEffectivenessData[0];
    let mPerfomanceData = {
      id: "Perfomance",
      color: "green",
      priority: 4,
      data: result.perfomanceData,
    };
    let mAvailabilityData = {
      id: "Availability",
      color: "blue",
      priority: 3,
      data: result.availabilityData,
    };

    let mOEEData = {
      id: "OEE",
      color: "orange",
      priority: 1,
      data: result.OEEData,
    };
    let mQualityData = {
      id: "Quality",
      color: "brown",
      priority: 2,
      data: result.qualityData,
    };

    mPerfomanceData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));
    mAvailabilityData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));
    mQualityData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));
    mOEEData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));

    let graphsData = new Array<any>();
    graphsData.push(mPerfomanceData);
    graphsData.push(mAvailabilityData);
    graphsData.push(mOEEData);
    graphsData.push(mQualityData);
    graphsData.sort((a: any, b: any) => (a.priority < b.priority ? 1 : -1));
    if (hasData) {
      return (
        <PreUseLineGraphComponent
          data={graphsData}
          xLabel={"Utilisation(%)"}
          yLabel={"Availability(%)"}
          colorSeries={["green", "blue", "orange", "brown"]}
        />
      );
    } else {
      return (
        <div
          style={{
            height: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          }}
        >
          <img
            src={emptyTrash}
            style={{ width: 40, height: 40 }}
            alt="Empty Trash"
          />
          <Typography
            variant="h5"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`No data available for`.toUpperCase()}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`${getMomentDate(
              this.state.filterComparisonDate.toDateString(),
              "DD/MM/YYYY"
            )}`}
          </Typography>
          <Typography
            variant={"body1"}
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`Select another date`}
          </Typography>
        </div>
      );
    }
  };
  handlePreuseEquipmentSelected = (value: any) => {
    let dataConvertAsync: DataConvertAsync = new DataConvertAsync();
    if (value === "All") {
      this.setState(
        {
          selectedPreuseMachineItem: value,
        },
        () => {
          this.drawBarGraphs();
        }
      );
    } else {
      this.state.mBarPreuseData.forEach((machineItem: any, index: any) => {
        if (machineItem.machine === value) {
          dataConvertAsync
            .convertToPreUseBarData(
              machineItem.preuseData,
              this.state.radioPreuseValue === "AllShifts" ? true : null
            )
            .then((resp: any) => {
              if (resp && resp.length > 0) {
                this.setState({
                  mBarDataPartA: resp,
                  selectedPreuseMachineItem: value,
                });
              }
            });
        }
      });
    }
  };
  handleEquipmentStatusSelected = (value: any) => {
    let dataConvertAsync: DataConvertAsync = new DataConvertAsync();
    this.setState(
      {
        selectedPreuseMachineStatusItem: value,
      },
      () => {
        if (value === "All") {
          this.drawBarGraphs();
        } else {
          this.state.mMachineStatusData.map((machineItem: any, index: any) => {
            if (machineItem.machine === value) {
              dataConvertAsync
                .getPreUseMachineStatusData(this.state.PreUseData, value)
                .then((resp: any) => {
                  this.setState({
                    mFilteredMachineStatusData: resp,
                    selectedPreuseMachineStatusItem: value,
                  });
                });
            }
            return null;
          });
        }
      }
    );
  };
  handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (newValue === 2 && this.state.isFiltering) {
      this.setState({ tabValue: newValue, isFiltering: false }, () => {
        this.getCompanyDetails();
      });
    } else {
      this.setState({ tabValue: newValue }, () => {
        this.drawBarGraphs();
      });
    }
  };

  handleRadioPreuseButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      { radioPreuseValue: (event.target as HTMLInputElement).value },
      () => {
        this.drawBarGraphs();
      }
    );
  };
  handleRadioOEEButtonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      { radioOEEValue: (event.target as HTMLInputElement).value },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioUtilityButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioUtilityValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioEffectivenessButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioEffectivenessValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioComplianceButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioComplianceValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioBreakdownButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioBreakdownValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioStandingButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioStandingValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      { ...this.state, [event.target.name]: event.target.checked },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  renderFilterContainer = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: -25,
          justifyContent: "center",
          flexDirection: "row",
          zIndex: 1,
        }}
      >
        <Paper
          elevation={3}
          style={{
            margin: 10,
            borderRadius: 12,
            alignSelf: "center",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Autocomplete
            id="combo-box-demo"
            options={this.state.employees}
            getOptionLabel={(employee) => employee.fullName}
            value={
              this.state.employeeFiltered.fullName
                ? this.state.employeeFiltered
                : null
            }
            style={{ width: 300 }}
            onChange={(event: any, value: any) => {
              if (!value) {
                this.setState(
                  {
                    employeeFiltered: { _id: "", fullName: "" },
                    PreUseData: this.state.originalList,
                    isFiltering: false,
                  },
                  () => {
                    this.handleApplyFilter();
                  }
                );
              } else {
                this.applyEmployeeFilter(value);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                id="standard-full-width"
                label="Filter Employee"
                style={{ paddingRight: 20, margin: 10 }}
                placeholder="Search..."
                fullWidth
                margin="normal"
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
              />
            )}
          />
        </Paper>
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="flex-start" style={{ margin: 10 }}>
              <Paper
                elevation={3}
                style={{
                  margin: 10,
                  borderRadius: 12,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <KeyboardDatePicker
                  style={{ margin: 10 }}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="From"
                  minDate={moment(new Date()).subtract(3, "months").toDate()}
                  autoOk
                  value={this.state.filterStartDate}
                  onChange={this.handleFilterStartDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Paper>
              <Paper
                elevation={3}
                style={{
                  margin: 10,
                  borderRadius: 12,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <KeyboardDatePicker
                  style={{ margin: 10 }}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="To"
                  minDate={this.state.filterStartDate}
                  maxDate={new Date()}
                  autoOk
                  value={this.state.filterEndDate}
                  onChange={this.handleFilterEndDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Paper>
            </Grid>
          </MuiPickersUtilsProvider>
        </div>

        {this.state.isFiltering ? (
          <Paper
            elevation={3}
            style={{
              borderRadius: 12,
              height: 60,
              padding: 5,
              alignSelf: "center",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              backgroundColor: this.state.isFiltering ? "#11b92d" : "white",
              flexDirection: "column",
            }}
          >
            <Button
              onClick={() => this.handleApplyFilter()}
              style={{ borderColor: "#11b92d", color: "white" }}
              variant="outlined"
              startIcon={<FilterListIcon style={{ color: "white" }} />}
            >
              Filter
            </Button>
          </Paper>
        ) : (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Paper
              elevation={3}
              style={{
                borderRadius: 12,
                height: 60,
                padding: 5,
                alignSelf: "center",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                backgroundColor: this.state.isFiltering ? "#11b92d" : "white",
                flexDirection: "column",
              }}
            >
              <Button
                onClick={() => this.handleApplyFilter()}
                style={{ borderColor: "white", color: "grey" }}
                variant="outlined"
                startIcon={<FilterListIcon />}
              >
                Filter
              </Button>
            </Paper>
            {!this.state.isFilteringCancel && (
              <Paper
                elevation={3}
                style={{
                  borderRadius: 12,
                  height: 60,
                  marginLeft: 10,
                  padding: 5,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  backgroundColor: this.state.isFiltering ? "#11b92d" : "white",
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={() =>
                    this.setState(
                      {
                        isFilteringCancel: true,
                        filterStartDate: this.state.filterStartOldDate,
                        filterEndDate: this.state.filterEndOldDate,
                      },
                      () => {
                        this.requestDataForDateRange();
                      }
                    )
                  }
                  style={{ borderColor: "white", color: "grey" }}
                  variant="outlined"
                  startIcon={<CloseIcon />}
                >
                  Cancel
                </Button>
              </Paper>
            )}
          </div>
        )}
      </div>
    );
  };

  renderMachineEffectivenessFilter = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: -25,
          justifyContent: "flex-end",
          flexDirection: "row",
          zIndex: 1,
        }}
      >
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="flex-start" style={{ margin: 10 }}>
              <Paper
                elevation={3}
                style={{
                  margin: 10,
                  borderRadius: 12,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <KeyboardDatePicker
                  style={{ margin: 10 }}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="Comparison Date"
                  autoOk
                  value={this.state.filterComparisonDate}
                  onChange={this.handleFilterComparisonDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Paper>
            </Grid>
          </MuiPickersUtilsProvider>
        </div>
      </div>
    );
  };

  renderTabForPreuseCharts = () => {
    const { classes } = this.props;
    let company: any = this.state.company;
    let equipments = this.getEquipmentsFromInspections(this.state.PreUseData);
    return (
      <div>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              alignItems: "center",
              height: 100,
              justifyContent: "space-between",
              paddingLeft: "2%",
              paddingRight: "2%",
            }}
          >
            <FormControl
              variant="outlined"
              style={{ flex: 0.3 }}
              className={classes.formControl}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                Equipment
              </InputLabel>
              <Select
                value={
                  this.state.selectedPreuseMachineItem
                    ? this.state.selectedPreuseMachineItem
                    : ""
                }
                onChange={(event: any) => {
                  if (event && event.target && event.target.value) {
                    this.handlePreuseEquipmentSelected(
                      event.target.value as string
                    );
                  }
                }}
                label="Equipments"
                inputProps={{
                  name: "Equipments",
                  id: "outlined-age-native-simple",
                }}
              >
                <MenuItem value={"All"}>{"All"}</MenuItem>
                {equipments.map((machineItem: any, index: any) => {
                  return (
                    <MenuItem
                      key={`machin-item-${index}`}
                      value={machineItem.machine}
                    >
                      {machineItem.machine}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="gender"
                name="shifts"
                value={this.state.radioPreuseValue}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
                onChange={(event: any) =>
                  this.handleRadioPreuseButtonChange(event)
                }
              >
                <FormControlLabel
                  value={"AllShifts"}
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                    />
                  }
                  label={"All Shifts"}
                />
                {company.shifts &&
                  company.shifts.length > 0 &&
                  company.shifts.map((shiftItem: any, index: any) => {
                    return (
                      <FormControlLabel
                        key={`shiftItem-${index}`}
                        value={shiftItem.label}
                        control={
                          <Radio
                            classes={{
                              root: classes.radio,
                              checked: classes.checked,
                            }}
                          />
                        }
                        label={shiftItem.label}
                      />
                    );
                  })}
              </RadioGroup>
            </FormControl>
          </div>
          <Divider />
          <ListItemText
            style={{
              padding: "1%",
            }}
            primaryTypographyProps={{
              style: { fontWeight: "bold" },
            }}
            primary={`Pre-Use Inspection Summary`}
            secondary={
              this.state.radioPreuseValue === "AllShifts"
                ? "All Shifts"
                : this.state.radioPreuseValue
            }
          />
          <Divider />
          {!this.state.preuseShiftIsNotEmpty ? (
            this.renderStatisticTable(this.state.selectedPreuseMachineItem)
          ) : (
            <div
              style={{
                height: 500,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                overflow: "auto",
              }}
            >
              <img
                src={emptyTrash}
                style={{ width: 40, height: 40 }}
                alt="Empty Trash"
              />
              <Typography
                variant="h5"
                gutterBottom
                style={{ marginTop: 10, textAlign: "center" }}
              >
                {"No data available".toUpperCase()}
              </Typography>
            </div>
          )}
        </div>
      </div>
    );
  };
  renderTabForUtilisationCharts = () => {
    const { classes } = this.props;
    let company: any = this.state.company;
    return (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            alignItems: "center",
            height: 100,
            justifyContent: "space-between",
            paddingLeft: "2%",
            paddingRight: "2%",
          }}
        >
          <FormControl
            variant="outlined"
            style={{ flex: 0.3 }}
            className={classes.formControl}
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              Equipment
            </InputLabel>
            <Select
              value={
                this.state.selectedUtilityMachineItem
                  ? this.state.selectedUtilityMachineItem
                  : ""
              }
              onChange={(event: any) => {
                if (event && event.target && event.target.value) {
                  this.setState({
                    selectedUtilityMachineItem: event.target.value as string,
                  });
                }
              }}
              label="Equipments"
              inputProps={{
                name: "Equipments",
                id: "outlined-age-native-simple",
              }}
            >
              {this.state.mMachineUtilityData.map(
                (machineItem: any, index: any) => {
                  return (
                    <MenuItem
                      key={`machineItem-${index}`}
                      value={machineItem.machine}
                    >
                      {machineItem.machine}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="shifts"
              value={this.state.radioUtilityValue}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              onChange={(event: any) =>
                this.handleRadioUtilityButtonChange(event)
              }
            >
              {company.shifts &&
                company.shifts.length > 0 &&
                company.shifts.map((shiftItem: any, index: any) => {
                  return (
                    <FormControlLabel
                      value={shiftItem.label}
                      key={`shift-item-${index}`}
                      control={
                        <Radio
                          classes={{
                            root: classes.radio,
                            checked: classes.checked,
                          }}
                        />
                      }
                      label={shiftItem.label}
                    />
                  );
                })}
            </RadioGroup>
          </FormControl>
        </div>
        <Divider />
        {this.state.mMachineUtilityData &&
        this.state.mMachineUtilityData.length > 0 &&
        !this.state.utilityShiftIsNotEmpty ? (
          <Grid container spacing={3}>
            {this.state.mMachineUtilityData.map(
              (machineItem: any, index: any) => {
                if (
                  machineItem.machine === this.state.selectedUtilityMachineItem
                ) {
                  return (
                    <Grid
                      key={`grid-item-${index}`}
                      item
                      xs={12}
                      style={{ marginBottom: 30 }}
                    >
                      <div
                        style={{
                          height: 500,
                          margin: 20,
                          borderRadius: 4,

                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginRight: "3%",
                          }}
                        >
                          <ListItemText
                            style={{
                              paddingLeft: "1%",
                            }}
                            primaryTypographyProps={{
                              style: { fontWeight: "bold" },
                            }}
                            primary={`${this.props.title} | ${this.state.selectedUtilityMachineItem}`}
                            secondary={`${this.state.radioUtilityValue}`}
                          />
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <CustomChecked
                                  checked={this.state.checkedAvailability}
                                  onChange={this.handleCheckBoxChange}
                                  name="checkedAvailability"
                                />
                              }
                              label="Availability"
                            />
                            <FormControlLabel
                              control={
                                <CustomChecked
                                  checked={this.state.checkedUtilisation}
                                  onChange={this.handleCheckBoxChange}
                                  name="checkedUtilisation"
                                />
                              }
                              label="Utilisation"
                            />
                            <FormControlLabel
                              control={
                                <CustomChecked
                                  checked={this.state.checkedQuality}
                                  onChange={this.handleCheckBoxChange}
                                  name="checkedQuality"
                                />
                              }
                              label="Quality"
                            />
                            <FormControlLabel
                              control={
                                <CustomChecked
                                  checked={this.state.checkedOEE}
                                  onChange={this.handleCheckBoxChange}
                                  name="checkedOEE"
                                />
                              }
                              label="OEE"
                            />
                          </FormGroup>
                        </div>

                        <Divider />
                        {this.renderUtilisationCharts(machineItem)}
                      </div>
                    </Grid>
                  );
                }
                return null;
              }
            )}
          </Grid>
        ) : (
          <div
            style={{
              height: 500,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "auto",
            }}
          >
            <img
              src={emptyTrash}
              style={{ width: 40, height: 40 }}
              alt="Empty Trash"
            />
            <Typography
              variant="h5"
              gutterBottom
              style={{ marginTop: 10, textAlign: "center" }}
            >
              {"No data available".toUpperCase()}
            </Typography>
          </div>
        )}
      </div>
    );
  };
  renderTabFotEffectiveness = () => {
    const { classes } = this.props;
    let company: any = this.state.company;
    let hasData = false;
    let mEffectivenessData =
      this.state.mMachineEffectivenessData &&
      this.state.mMachineEffectivenessData.length > 0
        ? this.state.mMachineEffectivenessData[0]
        : [];
    if (mEffectivenessData) {
      hasData =
        (mEffectivenessData.perfomanceData &&
          mEffectivenessData.perfomanceData.length > 0) ||
        (mEffectivenessData.availabilityData &&
          mEffectivenessData.availabilityData.length > 0) ||
        (mEffectivenessData.qualityData &&
          mEffectivenessData.qualityData.length > 0) ||
        (mEffectivenessData.OEEData && mEffectivenessData.OEEData.length > 0);
    }
    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <div
              style={{
                height: 500,
                borderRadius: 4,
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  alignItems: "center",
                  height: 100,
                  justifyContent: "flex-end",
                  paddingLeft: "2%",
                  paddingRight: "2%",
                }}
              >
                <ListItemText
                  style={{
                    paddingLeft: "1%",
                  }}
                  primaryTypographyProps={{
                    style: { fontWeight: "bold" },
                  }}
                  primary={`Overall Equipment Effective Comparision`}
                  secondary={`${getMomentDate(
                    this.state.filterComparisonDate.toISOString(),
                    "DD/MM/YYYY"
                  )}`}
                />
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    name="shifts"
                    value={this.state.radioEffectivenessValue}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                    onChange={(event: any) =>
                      this.handleRadioEffectivenessButtonChange(event)
                    }
                  >
                    {company.shifts &&
                      company.shifts.length > 0 &&
                      company.shifts.map((shiftItem: any, index: any) => {
                        return (
                          <FormControlLabel
                            key={`shift-tiem-item-${index}`}
                            value={shiftItem.label}
                            control={
                              <Radio
                                classes={{
                                  root: classes.radio,
                                  checked: classes.checked,
                                }}
                              />
                            }
                            label={shiftItem.label}
                          />
                        );
                      })}
                  </RadioGroup>
                </FormControl>
              </div>
              <Divider />
              {!this.state.effectivenssIsNotEmpty &&
              this.state.mMachineEffectivenessData &&
              this.state.mMachineEffectivenessData.length > 0 ? (
                this.renderMachineEffectivenessCharts(hasData)
              ) : (
                <div
                  style={{
                    height: 500,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "auto",
                  }}
                >
                  <img
                    src={emptyTrash}
                    style={{ width: 40, height: 40 }}
                    alt="Empty Trash"
                  />
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{ marginTop: 10, textAlign: "center" }}
                  >
                    {"No data available".toUpperCase()}
                  </Typography>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  renderTabForComplianceData = () => {
    const { classes } = this.props;
    let company: any = this.state.company;
    let equipments = this.getEquipmentsFromInspections(this.state.PreUseData);
    return (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            alignItems: "center",
            height: 100,
            justifyContent: "space-between",
            paddingLeft: "2%",
            paddingRight: "2%",
          }}
        >
          <FormControl
            variant="outlined"
            style={{ flex: 0.3 }}
            className={classes.formControl}
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              Equipment
            </InputLabel>
            <Select
              value={
                this.state.selectedPreuseComplianceItem
                  ? this.state.selectedPreuseComplianceItem
                  : ""
              }
              onChange={(event: any) => {
                if (event && event.target && event.target.value) {
                  this.setState(
                    {
                      selectedPreuseComplianceItem: event.target
                        .value as string,
                    },
                    () => {
                      this.drawBarGraphs();
                    }
                  );
                }
              }}
              label="Equipments"
              inputProps={{
                name: "Equipments",
                id: "outlined-age-native-simple",
              }}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {equipments.map((machineItem: any, index: any) => {
                return (
                  <MenuItem
                    key={`machineItem-${index}`}
                    value={machineItem.machine}
                  >
                    {machineItem.machine}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="shifts"
              value={this.state.radioComplianceValue}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              onChange={(event: any) =>
                this.handleRadioComplianceButtonChange(event)
              }
            >
              <FormControlLabel
                value={"AllShifts"}
                control={
                  <Radio
                    classes={{
                      root: classes.radio,
                      checked: classes.checked,
                    }}
                  />
                }
                label={"All Shifts"}
              />
              {company.shifts &&
                company.shifts.length > 0 &&
                company.shifts.map((shiftItem: any, index: any) => {
                  return (
                    <FormControlLabel
                      value={shiftItem.label}
                      key={`shift-item-${index}`}
                      control={
                        <Radio
                          classes={{
                            root: classes.radio,
                            checked: classes.checked,
                          }}
                        />
                      }
                      label={shiftItem.label}
                    />
                  );
                })}
            </RadioGroup>
          </FormControl>
        </div>
        <Divider />
        {this.state.mComplianceData &&
        this.state.mComplianceData.length > 0 &&
        !this.state.complianceIsNotEmpty ? (
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <div
                style={{
                  height: 500,
                  margin: 20,
                  borderRadius: 4,
                  width: "100%",
                }}
              >
                <Divider />
                <BarGraphComponentV2
                  data={this.state.mComplianceData}
                  legendAxisLeft={"Compliance Level"}
                  legendAxisBelow={"Signatories"}
                  indexBy={"who"}
                  keys={["Signed", "Not Signed"]}
                  useTick={true}
                  colors={["red", "green"]}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <div
            style={{
              height: 500,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "auto",
            }}
          >
            <img
              src={emptyTrash}
              style={{ width: 40, height: 40 }}
              alt="Empty Trash"
            />
            <Typography
              variant="h5"
              gutterBottom
              style={{ marginTop: 10, textAlign: "center" }}
            >
              {"No data available".toUpperCase()}
            </Typography>
          </div>
        )}
      </div>
    );
  };

  renderTabForBreakdownData = () => {
    const { classes } = this.props;
    let company: any = this.state.company;
    let equipments = this.getEquipmentsFromInspections(this.state.PreUseData);
    return (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            alignItems: "center",
            height: 100,
            justifyContent: "space-between",
            paddingLeft: "2%",
            paddingRight: "2%",
          }}
        >
          <FormControl
            variant="outlined"
            style={{ flex: 0.3 }}
            className={classes.formControl}
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              Equipment
            </InputLabel>
            <Select
              value={
                this.state.selectedPreuseBreakdownItem
                  ? this.state.selectedPreuseBreakdownItem
                  : ""
              }
              onChange={(event: any) => {
                if (event && event.target && event.target.value) {
                  this.setState(
                    {
                      selectedPreuseBreakdownItem: event.target.value as string,
                    },
                    () => {
                      this.drawBarGraphs();
                    }
                  );
                }
              }}
              label="Equipments"
              inputProps={{
                name: "Equipments",
                id: "outlined-age-native-simple",
              }}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {equipments.map((machineItem: any, index: any) => {
                return (
                  <MenuItem
                    key={`machineItem-${index}`}
                    value={machineItem.machine}
                  >
                    {machineItem.machine}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="shifts"
              value={this.state.radioBreakdownValue}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              onChange={(event: any) =>
                this.handleRadioBreakdownButtonChange(event)
              }
            >
              <FormControlLabel
                value={"AllShifts"}
                control={
                  <Radio
                    classes={{
                      root: classes.radio,
                      checked: classes.checked,
                    }}
                  />
                }
                label={"All Shifts"}
              />
              {company.shifts &&
                company.shifts.length > 0 &&
                company.shifts.map((shiftItem: any, index: any) => {
                  return (
                    <FormControlLabel
                      value={shiftItem.label}
                      key={`shift-item-${index}`}
                      control={
                        <Radio
                          classes={{
                            root: classes.radio,
                            checked: classes.checked,
                          }}
                        />
                      }
                      label={shiftItem.label}
                    />
                  );
                })}
            </RadioGroup>
          </FormControl>
        </div>
        <Divider />
        {this.state.mBreakdownData &&
        this.state.mBreakdownData.length > 0 &&
        !this.state.breakdownIsNotEmpty ? (
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <div
                style={{
                  height: 500,
                  margin: 20,
                  borderRadius: 4,
                  width: "100%",
                }}
              >
                <Divider />
                <BarGraphComponentV2
                  data={this.state.mBreakdownData}
                  legendAxisLeft={"Breakdown Duration (minutes)"}
                  legendAxisBelow={"Breakdowns"}
                  indexBy={"title"}
                  keys={["Breakdown"]}
                  colors={[
                    "hsl(131, 86%, 39%)",
                    "hsl(2, 95%, 51%)",
                    "hsl(54, 100%, 50%)",
                  ]}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <div
            style={{
              height: 500,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "auto",
            }}
          >
            <img
              src={emptyTrash}
              style={{ width: 40, height: 40 }}
              alt="Empty Trash"
            />
            <Typography
              variant="h5"
              gutterBottom
              style={{ marginTop: 10, textAlign: "center" }}
            >
              {"No data available".toUpperCase()}
            </Typography>
          </div>
        )}
      </div>
    );
  };

  renderTabForStandingData = () => {
    const { classes } = this.props;
    let company: any = this.state.company;
    let equipments = this.getEquipmentsFromInspections(this.state.PreUseData);
    return (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            alignItems: "center",
            height: 100,
            justifyContent: "space-between",
            paddingLeft: "2%",
            paddingRight: "2%",
          }}
        >
          <FormControl
            variant="outlined"
            style={{ flex: 0.3 }}
            className={classes.formControl}
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              Equipment
            </InputLabel>
            <Select
              value={
                this.state.selectedPreuseStandingItem
                  ? this.state.selectedPreuseStandingItem
                  : ""
              }
              onChange={(event: any) => {
                if (event && event.target && event.target.value) {
                  this.setState(
                    {
                      selectedPreuseStandingItem: event.target.value as string,
                    },
                    () => {
                      this.drawBarGraphs();
                    }
                  );
                }
              }}
              label="Equipments"
              inputProps={{
                name: "Equipments",
                id: "outlined-age-native-simple",
              }}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {equipments.map((machineItem: any, index: any) => {
                return (
                  <MenuItem
                    key={`machineItem-${index}`}
                    value={machineItem.machine}
                  >
                    {machineItem.machine}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="shifts"
              value={this.state.radioStandingValue}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              onChange={(event: any) =>
                this.handleRadioStandingButtonChange(event)
              }
            >
              <FormControlLabel
                value={"AllShifts"}
                control={
                  <Radio
                    classes={{
                      root: classes.radio,
                      checked: classes.checked,
                    }}
                  />
                }
                label={"All Shifts"}
              />
              {company.shifts &&
                company.shifts.length > 0 &&
                company.shifts.map((shiftItem: any, index: any) => {
                  return (
                    <FormControlLabel
                      value={shiftItem.label}
                      key={`shift-item-${index}`}
                      control={
                        <Radio
                          classes={{
                            root: classes.radio,
                            checked: classes.checked,
                          }}
                        />
                      }
                      label={shiftItem.label}
                    />
                  );
                })}
            </RadioGroup>
          </FormControl>
        </div>
        <Divider />
        {this.state.mStandingData &&
        this.state.mStandingData.length > 0 &&
        !this.state.standingIsNotEmpty ? (
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <div
                style={{
                  height: 500,
                  margin: 20,
                  borderRadius: 4,
                  width: "100%",
                }}
              >
                <Divider />
                <BarGraphComponentV2
                  data={this.state.mStandingData}
                  legendAxisLeft={"Standing Duration (minutes)"}
                  legendAxisBelow={"Standings"}
                  indexBy={"title"}
                  keys={["Standing"]}
                  colors={[
                    "hsl(131, 86%, 39%)",
                    "hsl(2, 95%, 51%)",
                    "hsl(54, 100%, 50%)",
                  ]}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <div
            style={{
              height: 500,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "auto",
            }}
          >
            <img
              src={emptyTrash}
              style={{ width: 40, height: 40 }}
              alt="Empty Trash"
            />
            <Typography
              variant="h5"
              gutterBottom
              style={{ marginTop: 10, textAlign: "center" }}
            >
              {"No data available".toUpperCase()}
            </Typography>
          </div>
        )}
      </div>
    );
  };
  getStatusIndicator = (shift: any, date: any, machineStatusData: any) => {
    let indicator = "";
    let foundObj = machineStatusData.filter((item: any) => {
      return item.shift === shift && item.date === date;
    });
    if (foundObj && foundObj.length > 0) {
      indicator = foundObj[0].indicator;
    }
    return indicator;
  };

  renderEquipmentStatusChart = () => {
    const { classes } = this.props;
    let dataConvertAsync = new DataConvertAsync();
    let daysBetween = dataConvertAsync.getDaysBetweenTwoDates(
      this.state.filterStartDate,
      this.state.filterEndDate
    );
    let startMoment = moment(this.state.filterStartDate.toDateString());
    let endMoment = moment(this.state.filterEndDate.toDateString());
    let diffDays = moment.duration(endMoment.diff(startMoment)).asDays();
    let isBefore = endMoment.isBefore(startMoment);
    if (
      (!isBefore || diffDays === 0) &&
      (this.state.isFiltering || this.state.isFilteringCancel)
    ) {
      return (
        <div>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flex: 1,
                alignItems: "center",
                height: 100,
                justifyContent: "space-between",
              }}
            >
              <FormControl
                variant="outlined"
                style={{ flex: 0.2 }}
                className={classes.formControl}
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  Equipment
                </InputLabel>
                <Select
                  value={
                    this.state.selectedPreuseMachineStatusItem
                      ? this.state.selectedPreuseMachineStatusItem
                      : ""
                  }
                  onChange={(event: any) => {
                    if (event && event.target && event.target.value) {
                      this.handleEquipmentStatusSelected(
                        event.target.value as string
                      );
                    }
                  }}
                  label="Equipments"
                  inputProps={{
                    name: "Equipments",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <MenuItem value={"All"}>{"All"}</MenuItem>
                  {this.state.mMachineStatusData.map(
                    (machineItem: any, index: any) => {
                      return (
                        <MenuItem
                          key={`machin-item-${index}`}
                          value={machineItem.machine}
                        >
                          {machineItem.machine}
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
              </FormControl>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                {[
                  { label: "GO", color: "green" },
                  { label: "NO-GO", color: "red" },
                  { label: "GO-BUT", color: "orange" },
                  { label: "NO-DATA available", color: "grey" },
                ].map((item: any, index: any) => {
                  return (
                    <div
                      key={`${index}-items-page`}
                      style={{
                        display: "flex",
                        margin: 20,
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: 15,
                          height: 15,
                          borderRadius: 15,
                          backgroundColor: item.color,
                        }}
                      />
                      <Typography>{item.label}</Typography>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <EquipmentStatusTableComponent
            data={
              this.state.selectedPreuseMachineStatusItem === "All"
                ? this.state.mMachineStatusData
                : this.state.mFilteredMachineStatusData
            }
            columns={daysBetween}
            retrieveIndicator={this.getStatusIndicator}
          />
        </div>
      );
    } else {
      return (
        <div
          style={{
            height: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          }}
        >
          <img
            src={emptyTrash}
            style={{ width: 40, height: 40 }}
            alt="Empty Trash"
          />
          <Typography
            variant="h5"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {"No data available".toUpperCase()}
          </Typography>
          <Typography
            variant="caption"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {"Pleas check your date sequence"}
          </Typography>
        </div>
      );
    }
  };

  render() {
    const { classes, profileData } = this.props;
    return (
      <AuthConsumer>
        {({ user, accessRules }) => {
          return (
            <div className={classes.root}>
              <LoadingComponents isLoading={this.state.isLoading} />
              <CssBaseline />
              <ThemeProvider theme={defaultTheme}>
                <AppBar
                  position="fixed"
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: this.state.open,
                  })}
                >
                  <Toolbar>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            alignItems: "flex-start",
                            textAlign: "start",
                            flex: 1,
                          }}
                        >
                          <Typography variant="h6" noWrap>
                            Main Dashboard
                          </Typography>
                        </div>

                        <div
                          style={{
                            flex: 0.5,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <HasPermission
                            role={user.role}
                            accessRules={accessRules}
                            perform="dashboard:create"
                            yes={() => (
                              <div style={{ visibility: "hidden" }}>
                                <Button
                                  type="submit"
                                  onClick={() => this.openAddData()}
                                  color="inherit"
                                >
                                  <AddIcon
                                    style={{ margin: 10 }}
                                    className={classes.extendedIcon}
                                  />
                                  Add Data
                                </Button>
                              </div>
                            )}
                            no={() => {
                              return null;
                            }}
                          ></HasPermission>

                          {profileData &&
                          profileData.role &&
                          profileData.role === ROLES.DASHBOARD ? (
                            <Button
                              type="submit"
                              onClick={() => this.onToolBarButtonClicked()}
                              color="inherit"
                            >
                              <LockOpenIcon
                                style={{ margin: 10 }}
                                className={classes.extendedIcon}
                              />
                              Logout
                            </Button>
                          ) : (
                            <Button
                              type="submit"
                              onClick={() => this.onToolBarCloseButtonClicked()}
                              color="inherit"
                            >
                              <CloseIcon
                                style={{ margin: 10 }}
                                className={classes.extendedIcon}
                              />
                              Close
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Toolbar>
                </AppBar>
              </ThemeProvider>
              <div className={classes.content}>
                <div className={classes.toolbar} />
                {this.state.tabValue > -1 &&
                this.state.tabValue <
                  (this.props.type !==
                  DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD
                    ? 6
                    : 5)
                  ? this.renderFilterContainer()
                  : this.renderMachineEffectivenessFilter()}
                {this.state.PreUseData && this.state.PreUseData.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      height: "100%",
                      width: "100%",
                      flexDirection: "column",
                    }}
                  >
                    <Tabs
                      value={this.state.tabValue}
                      onChange={this.handleTabChange}
                      aria-label="simple tabs example"
                      style={{ marginLeft: "2%" }}
                    >
                      <Tab label="Equipment Status" />
                      <Tab label="Pre-Use Inspection" />
                      <Tab label="Compliance" />
                      <Tab label="Breakdown" />
                      {this.props.type !==
                        DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD && (
                        <Tab label="Standing" />
                      )}
                      <Tab label={`${this.props.title} OEE`} />
                      <Tab label="OEE Comparison" />
                    </Tabs>
                    <TabPanel value={this.state.tabValue} index={0}>
                      {this.renderEquipmentStatusChart()}
                    </TabPanel>
                    <TabPanel value={this.state.tabValue} index={1}>
                      {(this, this.renderTabForPreuseCharts())}
                    </TabPanel>
                    <TabPanel value={this.state.tabValue} index={2}>
                      {this.renderTabForComplianceData()}
                    </TabPanel>
                    <TabPanel value={this.state.tabValue} index={3}>
                      {this.renderTabForBreakdownData()}
                    </TabPanel>
                    {this.props.type !==
                      DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD && (
                      <TabPanel value={this.state.tabValue} index={4}>
                        {this.renderTabForStandingData()}
                      </TabPanel>
                    )}
                    <TabPanel
                      value={this.state.tabValue}
                      index={
                        this.props.type ===
                        DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD
                          ? 4
                          : 5
                      }
                    >
                      {this.renderTabForUtilisationCharts()}
                    </TabPanel>
                    <TabPanel
                      value={this.state.tabValue}
                      index={
                        this.props.type ===
                        DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD
                          ? 5
                          : 6
                      }
                    >
                      {this.renderTabFotEffectiveness()}
                    </TabPanel>
                  </div>
                )}
                {isEmptyArray(this.state.PreUseData) && (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "auto",
                    }}
                  >
                    <img
                      src={emptyTrash}
                      style={{ width: 40, height: 40 }}
                      alt="Empty Trash"
                    />
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: 10, textAlign: "center" }}
                    >
                      {"No data available".toUpperCase()}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          );
        }}
      </AuthConsumer>
    );
  }
}
export default withStyles(styles)(PreUseInspectionDashboard);
